module.exports = __webpack_public_path__ + "static/img/photo_ceju01.b77f4bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/photo/photo_ceju01.png
// module id = xTEx
// module chunks = 12